import { graphql } from '../graphql/generated';

export const FIBU_EXPORT_QUERY = graphql(`
  query FibuExport {
    assignmentForCurrentUser {
      id
      primaryDoctor {
        id
        assignedLabs {
          lab {
            id
            name
            identifier
          }
        }
      }
    }
  }
`);
